function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 15.4v-4.8m0 0l-1.6 1.8m1.6-1.8l1.6 1.8m2.4.6v4.8m0 0l1.6-1.8M14 17.8L12.4 16",
  stroke: "#4D4D4D",
  strokeWidth: 1.215,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 8h14M5 8a2 2 0 010-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8",
  stroke: "#4D4D4D",
  strokeWidth: 1.651,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgOperar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/operar.svg";
export { SvgOperar as ReactComponent };